<label class="switch">
    <input type="checkbox" [checked]="isChecked" (change)="onToggle($event)" />
    <span class="slider">
        <span class="toggle-text" [class.selected]="isChecked">{{ isChecked ? 'Yes' : 'No' }}</span>
    </span>
</label>
<span class="switch-label"
    style="margin-left: 12px; vertical-align: middle;">{{ label }}
</span>